import headerLogo from '../assets/images/rice-work-logo.png';
import logoDark from '../assets/images/rice-work-logo.png';
import logoLight from '../assets/images/rice-work-logo.png';

const APP_NAME = process.env.REACT_APP_APP_NAME || 'RICE-WORK';

export default {
  APP_NAME,
  headerLogo,
  logoDark,
  logoLight,
};
